/**
 * H5 16kHz PCM 工具（legacy Gateway PCM；client-side STT 不再推 binary）
 */

export const TARGET_SAMPLE_RATE = 16000

/** Float32 样本转 Int16 LE PCM */
export function floatTo16BitPcm(input: Float32Array): ArrayBuffer {
  const output = new Int16Array(input.length)
  for (let i = 0; i < input.length; i++) {
    const sample = Math.max(-1, Math.min(1, input[i]))
    output[i] = sample < 0 ? sample * 0x8000 : sample * 0x7fff
  }
  return output.buffer
}

/** 线性插值重采样到 16kHz */
export function resampleToTargetRate(
  input: Float32Array,
  inputRate: number,
  outputRate: number = TARGET_SAMPLE_RATE,
): Float32Array {
  if (!input.length || Math.abs(inputRate - outputRate) < 1) {
    return input
  }
  const ratio = inputRate / outputRate
  const outLen = Math.max(1, Math.round(input.length / ratio))
  const out = new Float32Array(outLen)
  for (let i = 0; i < outLen; i++) {
    const pos = i * ratio
    const i0 = Math.floor(pos)
    const i1 = Math.min(i0 + 1, input.length - 1)
    const frac = pos - i0
    out[i] = input[i0] * (1 - frac) + input[i1] * frac
  }
  return out
}

/** 浏览器麦克风 acquire（PTT 须在 user gesture 内调用） */
export async function acquireMicStream(): Promise<MediaStream> {
  return navigator.mediaDevices.getUserMedia({
    audio: {
      channelCount: 1,
      echoCancellation: true,
      noiseSuppression: true,
    },
  })
}

export function releaseMicStream(stream: MediaStream | null): void {
  stream?.getTracks().forEach((t) => t.stop())
}
